import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import RutContainer from '../components/RutContainer';
import '../styles/RutPage.css';
import { Client } from '../components/Interfaces';
import { ClipLoader } from 'react-spinners';

const nestApiURL = process.env.REACT_APP_NEST_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function RutPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const params: URLSearchParams = new URLSearchParams(window.location.search);
  const uid: string | null = params.get('uid');
  const id: string | null = params.get('id');
  const [dataISOcountries, setDataISOcountries] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${nestApiURL}/countries`, {
      headers: { 'API_KEY': apiKey },
    }).then((response: any) => {
      if (response?.data?.status === 'success') {
        setDataISOcountries(response.data.data);
      }
    }).catch(() => {});
  }, []);

  const setRutFromRutContainer = (thisRut: string, documentType: string, nacionalidad?: string) => {
    setIsLoading(true);
    searchByRut(thisRut, documentType, nacionalidad ?? '');
  };

  const searchByRut = async (searchRut: string, documentType: string, nacionalidad: string) => {
    let formattedRut = searchRut;
    let selectedCountryId: number | string = '';

    // 1. BLINDAJE: Si la lista de países no alcanzó a cargar en el useEffect, la forzamos a cargar ahora
    let countriesList = dataISOcountries;
    if (countriesList.length === 0) {
      try {
        const res = await axios.get(`${nestApiURL}/countries`, { headers: { 'API_KEY': apiKey } });
        if (res?.data?.status === 'success') {
          countriesList = res.data.data;
          setDataISOcountries(countriesList);
        }
      } catch (e) {
        console.error("Error cargando países:", e);
      }
    }

    // 2. BÚSQUEDA TODO TERRENO: Cruzamos el país por ID, por isonum o por nombre exacto
    if (documentType === 'pasaporte' && nacionalidad) {
      const country = countriesList.find((c: any) => 
        String(c.id) === String(nacionalidad) || 
        String(c.isonum) === String(nacionalidad) ||
        (c.nombre && c.nombre.toLowerCase().trim() === String(nacionalidad).toLowerCase().trim())
      );
      
      if (country) {
        formattedRut = `${searchRut}${country.isonum}`;
        selectedCountryId = country.id; // ¡Capturamos el ID correcto para la BD!
      } else {
        console.warn("⚠️ No logramos cruzar el país enviado por RutContainer:", nacionalidad);
      }
    }

    // 3. Buscar al paciente en NestJS
    axios.get(`${nestApiURL}/patients/${formattedRut}`, {
      headers: {
        'API_KEY': apiKey, 
      },
    }).then((response: any) => {
      if (response?.data?.status === 'success' && response?.data?.data?.length > 0) {
        const clientData = response.data.data[0];
        
        const data: Client = {
          nombre: clientData.nombre,
          paterno: clientData.paterno,
          materno: clientData.materno,
          correo: clientData.email,                     
          celular: clientData.celular,
          sexo: clientData.sexo,
          direccion: clientData.direccion,
          region: clientData.city,                      
          comuna: clientData.state,                     
          fechaNacimiento: clientData.fecha_de_nacimiento, 
          edad: clientData.edad,                        
          prevision: clientData.prevision,
          nacionalidad: clientData.country_code,        
          ocupacion: clientData.occupation,
          concentimiento: Number(clientData.consentimiento) || 0,  
          rut: clientData["Rut/DNI"],                   
          ss: clientData["Rut/DNI"],                    
          confirmacion_correo: clientData.conf_verifalia, 
          pasaporte: documentType === 'pasaporte' ? true : false,
        };
        
        setIsLoading(false);
        navigate('/filter', { state: { message: `${id}`, clientData: data, uid } });
      } else {
        throw new Error("Datos no encontrados en la respuesta");
      }
    }).catch(() => {
      const data: Client = {} as Client;
      // Guardamos el documento original (sin isonum) para que el formulario sepa cuál es el DNI base
      data.rut = documentType === 'pasaporte' ? formattedRut : searchRut; 
      data.ss = searchRut; 
      data.pasaporte = documentType === 'pasaporte' ? true : false;
      
      // Pasamos el ID exacto al formulario final, forzando a String() para evitar enojos de TypeScript
      if (selectedCountryId) {
        data.nacionalidad = String(selectedCountryId); 
      }

      setIsLoading(false);
      navigate('/filter', { state: { message: `${id}`, clientData: data, uid } });
    });
  };

  return (
    <div className="appBody">
        {isLoading
          ? (<ClipLoader size={35} color="#5ab542" />) : <RutContainer setRutFromThis={setRutFromRutContainer} />}
    </div>
  );
}